// extracted by mini-css-extract-plugin
export default {"imgContain":"NJ","content":"OJ","titleAndImage":"PJ","title":"QJ","text":"RJ","rhodeTitle":"SJ","shortHR":"TJ","modal_root":"UJ","x_mark":"VJ","flavorStickModal":"WJ","greenBox":"XJ"};
    if(module.hot) {
      // 1715188236802
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  